import { render, staticRenderFns } from "./educacionFormal.vue?vue&type=template&id=1309d69a"
import script from "./educacionFormal.vue?vue&type=script&lang=js"
export * from "./educacionFormal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports